import {createUseStyles} from 'react-jss'

export default createUseStyles({
  container: {
    overflow: "hidden",
    position: 'relative',
    '&:hover': {
      backgroundColor: "#0265c9",
      
    },

  },
  children: {
    position: 'relative',
    zIndex: 2
  },
  ball: {
    zIndex: 1,
    position: 'absolute',
    width: 1,
    height: 1,
    backgroundColor: "#ffffff50",
    zIndex: 999,
    transformOrigin: '50% 50%',
    borderRadius: '50%',
    '&.selected': {
      transform: 'scale(100)',
    },
  },

  clickedBall: {
    transform: 'scale(0)',
    animation: "$ballAnim 0.7s"
  },

 
  '@keyframes ballAnim': {
    '0%': {transform: "scale(0)", opacity: 1},
    '50%': {transform: "scale(100)", opacity: 0.8},
    '100%': {transform: "scale(200)", opacity: 0}
    
  }
})